import { useState, useEffect } from 'react'
import Modal from 'react-responsive-modal';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import { getSubsctiption } from '../../../adminPanel/networkRequests/requests/subscription';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';

function validateEmail(email) {
    var re = /\S+@\S+\.\S+/;
    return re.test(email);
}

const SubscriptionForm = (props) => {
    const [email, setEmail] =useState('');
    const [b_hp_email, setB_hp_email] = useState('');
    const [submitting, setSubmitting] =useState(false);
    const { executeRecaptcha } = useGoogleReCaptcha();

    const handleEmailChange =(e) => {
        setEmail(e.target.value)
    }

    const onSubscription = async () => {
        if (submitting || b_hp_email) return;

        if(validateEmail(email)) {
            setSubmitting(true);
            if (!executeRecaptcha) {
                toast.error('reCAPTCHA not ready');
                setSubmitting(false);
                return;
            }
            const captchaToken = await executeRecaptcha('subscription');
            getSubsctiption(email, captchaToken, b_hp_email).then(res => {
                console.log(res);
                setEmail("");
                toast.success('You have successfully subscribed to our newsletter');
                setSubmitting(false);
            })
            .catch((err) => {
                console.log("error", err);
                toast.error('Something went wrong!');
                setSubmitting(false);
            });
        } else {
            toast.error('Please Enter Valid Email ID');
        }       
    }

    const history = useHistory();
    return (
        <>
            <div className='sh-subscription__form d-md-flex justify-content-between'>
                <input type="text" name="b_hp_email" style={{ display: 'none' }} tabIndex={-1} autoComplete="off" value={b_hp_email || ''} onChange={(e) => setB_hp_email(e.target.value)} />
                <input className={`sh-subscription__form-input ${props.additionalClass}`} type="email" name="email" placeholder="Enter your email id " value={email} onChange={handleEmailChange} disabled={submitting} />
                <button 
                    className={`sh-subscription__form-btn sh-button hover-color ${submitting ? 'sh-button--loading' : ''}`}  
                    onClick={onSubscription}
                    disabled={submitting}
                    style={{ border: 'none', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                >
                    {submitting && <span className="sh-spinner"></span>}
                    {submitting ? 'Submitting...' : 'Subscribe now'}
                </button>
            </div>
        </>
        

    )
}

export default SubscriptionForm;